import {
	documentByID,
	documentCreate,
	documentDestroy,
	documentList,
	documentUpdate,
	influencerByID,
	influencerCreate,
	influencerDestroy,
	influencerList,
	influencerUpdate,
	professionalByID,
	professionalCreate,
	professionalDestroy,
	professionalList,
	professionalUpdate,
	socialByID,
	socialCreate,
	socialDestroy,
	socialList,
	socialUpdate,
	professionalReview,
} from '@/services/agency/influencers.service'

export default {
	namespaced: true,
	state: {
		//  INFLUENCER
		influencerList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		influencer: {},

		// STATUS INFLUENCER
		influencerStatus: 'pending',
		influencerSaveStatus: 'init',
		influencerDeleteStatus: 'init',

		//  PROFESSIONAL
		professionalList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		professional: {},

		// STATUS PROFESSIONAL
		professionalStatus: 'pending',
		professionalSaveStatus: 'init',
		professionalDeleteStatus: 'init',

		//  SOCIAL
		socialList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		social: {},

		// STATUS SOCIAL
		socialStatus: 'pending',
		socialSaveStatus: 'init',
		socialDeleteStatus: 'init',

		//  DOCUMENT
		documentList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		document: {},

		// STATUS DOCUMENT
		documentStatus: 'pending',
		documentSaveStatus: 'init',
		documentDeleteStatus: 'init',
	},
	getters: {
		//  INFLUENCER
		getInfluencerList(state) {
			return state.influencerList
		},
		getInfluencer(state) {
			return state.influencer
		},

		// INFLUENCER
		getInfluencerDeleteStatus(state) {
			return state.influencerDeleteStatus
		},
		getInfluencerSaveStatus(state) {
			return state.influencerSaveStatus
		},
		getInfluencerStatus(state) {
			return state.influencerStatus
		},

		//  PROFESSIONAL
		getProfessionalList(state) {
			return state.professionalList
		},
		getProfessional(state) {
			return state.professional
		},

		// PROFESSIONAL
		getProfessionalDeleteStatus(state) {
			return state.professionalDeleteStatus
		},
		getProfessionalSaveStatus(state) {
			return state.professionalSaveStatus
		},
		getProfessionalStatus(state) {
			return state.professionalStatus
		},

		//  SOCIAL
		getSocialList(state) {
			return state.socialList
		},
		getSocial(state) {
			return state.social
		},

		// SOCIAL
		getSocialDeleteStatus(state) {
			return state.socialDeleteStatus
		},
		getSocialSaveStatus(state) {
			return state.socialSaveStatus
		},
		getSocialStatus(state) {
			return state.socialStatus
		},

		//  DOCUMENT
		getDocumentList(state) {
			return state.documentList
		},
		getDocument(state) {
			return state.document
		},

		// DOCUMENT
		getDocumentDeleteStatus(state) {
			return state.documentDeleteStatus
		},
		getDocumentSaveStatus(state) {
			return state.documentSaveStatus
		},
		getDocumentStatus(state) {
			return state.documentStatus
		},
	},
	mutations: {
		//  INFLUENCER
		INFLUENCER_LIST(state, value) {
			state.influencerList = value
		},
		SET_INFLUENCER(state, value) {
			state.influencer = value
		},

		// STATUS  INFLUENCER
		INFLUENCER_STATUS(state, value) {
			state.influencerStatus = value
		},
		INFLUENCER_SAVE_STATUS(state, value) {
			state.influencerSaveStatus = value
		},
		INFLUENCER_DELETE_STATUS(state, value) {
			state.influencerDeleteStatus = value
		},

		//  PROFESSIONAL
		PROFESSIONAL_LIST(state, value) {
			state.professionalList = value
		},
		SET_PROFESSIONAL(state, value) {
			state.professional = value
		},

		// STATUS  PROFESSIONAL
		PROFESSIONAL_STATUS(state, value) {
			state.professionalStatus = value
		},
		PROFESSIONAL_SAVE_STATUS(state, value) {
			state.professionalSaveStatus = value
		},
		PROFESSIONAL_DELETE_STATUS(state, value) {
			state.professionalDeleteStatus = value
		},

		//  SOCIAL
		SOCIAL_LIST(state, value) {
			state.socialList = value
		},
		SET_SOCIAL(state, value) {
			state.social = value
		},

		// STATUS  SOCIAL
		SOCIAL_STATUS(state, value) {
			state.socialStatus = value
		},
		SOCIAL_SAVE_STATUS(state, value) {
			state.socialSaveStatus = value
		},
		SOCIAL_DELETE_STATUS(state, value) {
			state.socialDeleteStatus = value
		},

		//  DOCUMENT
		DOCUMENT_LIST(state, value) {
			state.documentList = value
		},
		SET_DOCUMENT(state, value) {
			state.document = value
		},

		// STATUS  DOCUMENT
		DOCUMENT_STATUS(state, value) {
			state.documentStatus = value
		},
		DOCUMENT_SAVE_STATUS(state, value) {
			state.documentSaveStatus = value
		},
		DOCUMENT_DELETE_STATUS(state, value) {
			state.documentDeleteStatus = value
		},
	},
	actions: {
		async fetchInfluencerList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('INFLUENCER_STATUS', 'pending')
			commit('INFLUENCER_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const merged = { per_page: 'all', ...params }
				const { data } = await influencerList(merged)
				commit('INFLUENCER_STATUS', 'init')
				commit('INFLUENCER_LIST', data)
				return data
			} catch (error) {
				commit('INFLUENCER_STATUS', 'init')
				throw error
			}
		},
		async fetchInfluencerByID({ commit }, params) {
			commit('INFLUENCER_STATUS', 'pending')
			try {
				const { data } = await influencerByID(params)
				commit('INFLUENCER_STATUS', 'init')
				commit('SET_INFLUENCER', data.data)
				return data
			} catch (error) {
				commit('INFLUENCER_STATUS', 'init')
				// Drop whatever was loaded before: leaving the previous influencer in
				// place makes a failed load look like a successful one for the record
				// the URL now points at.
				commit('SET_INFLUENCER', {})

				return error
			}
		},

		async saveNewInfluencer({ commit }, params) {
			commit('INFLUENCER_SAVE_STATUS', 'pending')
			try {
				const { data } = await influencerCreate(params)
				commit('INFLUENCER_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INFLUENCER_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateInfluencer({ commit }, params) {
			commit('INFLUENCER_SAVE_STATUS', 'pending')
			try {
				const { data } = await influencerUpdate(params)
				commit('INFLUENCER_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INFLUENCER_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteInfluencerByID({ commit }, params) {
			commit('INFLUENCER_DELETE_STATUS', 'pending')
			try {
				const { data } = await influencerDestroy(params)
				commit('INFLUENCER_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INFLUENCER_DELETE_STATUS', 'error')

				return error
			}
		},

		// PROFESSIONAL
		async fetchProfessionalList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('PROFESSIONAL_STATUS', 'pending')
			commit('PROFESSIONAL_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await professionalList(params)
				commit('PROFESSIONAL_STATUS', 'init')
				commit('PROFESSIONAL_LIST', data)
				return data
			} catch (error) {
				commit('PROFESSIONAL_STATUS', 'init')
				throw error
			}
		},
		async fetchProfessionalByID({ commit }, params) {
			commit('PROFESSIONAL_STATUS', 'pending')
			try {
				const { data } = await professionalByID(params)
				commit('PROFESSIONAL_STATUS', 'init')
				commit('SET_PROFESSIONAL', data.data)
				return data
			} catch (error) {
				commit('PROFESSIONAL_STATUS', 'init')

				return error
			}
		},

		async saveNewProfessional({ commit }, params) {
			commit('PROFESSIONAL_SAVE_STATUS', 'pending')
			try {
				const { data } = await professionalCreate(params)
				commit('PROFESSIONAL_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('PROFESSIONAL_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateProfessional({ commit }, params) {
			commit('PROFESSIONAL_SAVE_STATUS', 'pending')
			try {
				const { data } = await professionalUpdate(params)
				commit('PROFESSIONAL_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('PROFESSIONAL_SAVE_STATUS', 'init')
				throw error
			}
		},
		async reviewProfessional({ commit }, { id, status, notes }) {
			commit('PROFESSIONAL_SAVE_STATUS', 'pending')
			try {
				const { data } = await professionalReview(id, status, notes)
				commit('PROFESSIONAL_SAVE_STATUS', 'init')
				commit('SET_PROFESSIONAL', data.data)
				return data
			} catch (error) {
				commit('PROFESSIONAL_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteProfessionalByID({ commit }, params) {
			commit('PROFESSIONAL_DELETE_STATUS', 'pending')
			try {
				const { data } = await professionalDestroy(params)
				commit('PROFESSIONAL_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('PROFESSIONAL_DELETE_STATUS', 'error')

				return error
			}
		},

		// SOCIAL
		async fetchSocialList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('SOCIAL_STATUS', 'pending')
			commit('SOCIAL_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await socialList(params)
				commit('SOCIAL_STATUS', 'init')
				commit('SOCIAL_LIST', data)
				return data
			} catch (error) {
				commit('SOCIAL_STATUS', 'init')
				throw error
			}
		},
		async fetchSocialByID({ commit }, params) {
			commit('SOCIAL_STATUS', 'pending')
			try {
				const { data } = await socialByID(params)
				commit('SOCIAL_STATUS', 'init')
				commit('SET_SOCIAL', data.data)
				return data
			} catch (error) {
				commit('SOCIAL_STATUS', 'init')

				return error
			}
		},

		async saveNewSocial({ commit }, params) {
			commit('SOCIAL_SAVE_STATUS', 'pending')
			try {
				const { data } = await socialCreate(params)
				commit('SOCIAL_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SOCIAL_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateSocial({ commit }, params) {
			commit('SOCIAL_SAVE_STATUS', 'pending')
			try {
				const { data } = await socialUpdate(params)
				commit('SOCIAL_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SOCIAL_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteSocialByID({ commit }, params) {
			commit('SOCIAL_DELETE_STATUS', 'pending')
			try {
				const { data } = await socialDestroy(params)
				commit('SOCIAL_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SOCIAL_DELETE_STATUS', 'error')

				return error
			}
		},

		// DOCUMENT
		async fetchDocumentList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('DOCUMENT_STATUS', 'pending')
			commit('DOCUMENT_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await documentList(params)
				commit('DOCUMENT_STATUS', 'init')
				commit('DOCUMENT_LIST', data)
				return data
			} catch (error) {
				commit('DOCUMENT_STATUS', 'init')
				throw error
			}
		},
		async fetchDocumentByID({ commit }, params) {
			commit('DOCUMENT_STATUS', 'pending')
			try {
				const { data } = await documentByID(params)
				commit('DOCUMENT_STATUS', 'init')
				commit('SET_DOCUMENT', data.data)
				return data
			} catch (error) {
				commit('DOCUMENT_STATUS', 'init')

				return error
			}
		},

		async saveNewDocument({ commit }, params) {
			commit('DOCUMENT_SAVE_STATUS', 'pending')
			try {
				const { data } = await documentCreate(params)
				commit('DOCUMENT_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('DOCUMENT_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateDocument({ commit }, params) {
			commit('DOCUMENT_SAVE_STATUS', 'pending')
			try {
				const { data } = await documentUpdate(params)
				commit('DOCUMENT_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('DOCUMENT_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteDocumentByID({ commit }, params) {
			commit('DOCUMENT_DELETE_STATUS', 'pending')
			try {
				const { data } = await documentDestroy(params)
				commit('DOCUMENT_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('DOCUMENT_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
